import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFaq } from './useFaq';
import { Spinner } from '@/components/Spinner';

export function FaqList() {
  const { data, isLoading, error } = useFaq();
  const [open, setOpen] = useState<string | null>(null);
  const { t } = useTranslation();

  if (isLoading)
    return (
      <div className="py-8 text-center text-hint">
        <Spinner />
      </div>
    );
  if (error || !data || data.length === 0)
    return <p className="text-hint text-sm py-6">{t('faq.empty')}</p>;

  return (
    <ul className="flex flex-col gap-2">
      {data.map((item) => {
        const isOpen = open === item.id;
        return (
          <li
            key={item.id}
            className="rounded-2xl overflow-hidden transition-colors"
            style={{
              background: 'rgba(255,255,255,0.025)',
              border: `1px solid ${isOpen ? 'var(--line-2)' : 'var(--line-1)'}`,
              boxShadow: isOpen ? 'inset 0 1px 0 rgba(255,255,255,0.06)' : 'none',
            }}
          >
            <button
              type="button"
              className="w-full text-left px-4 py-3.5 flex items-center justify-between gap-3"
              aria-expanded={isOpen}
              onClick={() => setOpen(isOpen ? null : item.id)}
            >
              <span className="font-display font-semibold tracking-tight text-[14px] text-white">
                {item.question}
              </span>
              <span
                aria-hidden
                className="inline-flex items-center justify-center w-6 h-6 rounded-full transition-transform"
                style={{
                  border: '1px solid var(--line-2)',
                  transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)',
                  color: 'var(--text-2)',
                }}
              >
                +
              </span>
            </button>
            {isOpen ? (
              <div className="px-4 pb-4 text-sm text-white/65 leading-relaxed whitespace-pre-line">
                {item.answer}
              </div>
            ) : null}
          </li>
        );
      })}
    </ul>
  );
}
